import * as React from 'react';

import {FormField} from 'shells/form/form-field';
import {TextField} from 'shells/textfield/textfield';

type Props = {
    value: string;
    onChange: (arg1: string) => void;
    onEnter?: () => void;
};

export function Password(props: Props) {
    return (
        <FormField
            innerId='password'
            label='Email password'
            errorMessage={null} // TODO
        >
            <TextField
                // @ts-expect-error
                name='password'
                placeholder='••••••••'
                title='Password'
                type='password'
                value={props.value}
                onChange={props.onChange}
                onEnter={props.onEnter}
            />
        </FormField>
    );
}
